import { AccountType } from "models/accountSummary";
import { AccountOwner, Owners } from "models/applicationUsers";
import { StaffSportsCard } from "models/cards";
import { StaffPackage } from "models/packages";

export const ownershipValidator = async (supportSilentAccounts: boolean, owners: Owners) => {
    if (owners.customers.length === 0) {
        throw new Error(`${supportSilentAccounts ? 'Breaker' : 'At least one customer'} is required`);
    }

    if (owners.customers.some(c => !c) ||
        (supportSilentAccounts && owners.silentUsers.some(u => !u))) {
        throw new Error('One or more customer selectors are empty');
    }

    if (supportSilentAccounts && owners.silentUsers.length === 0) {
        throw new Error('A customer selection under the breaker is required')
    }
}

export const mapOwners = (entity: StaffPackage | StaffSportsCard): Owners => {
    if ("cardId" in entity) {
        return mapOwnersFromCard(entity);
    }

    return mapOwnersFromPackage(entity);
};

const mapOwnersFromPackage = (
    pkg: StaffPackage
): Owners => {
    if (pkg.accountType === AccountType.Silent) {
        return {
            customers: [{
                id: pkg.senderId,
                email: pkg.senderEmail,
                userName: pkg.senderUserName,
                firstName: pkg.senderFirstName,
                lastName: pkg.senderLastName
            }],
            silentUsers: pkg.owners.map(o => ({
                ...o,
                id: o.customerId,
                ownerId: pkg.senderId
            }))
        }
    }

    return consignmentOwnerMap(pkg.owners);
}

const mapOwnersFromCard = (
    card: StaffSportsCard
): Owners => {
    if (card.ownersAreSilent) {
        const { packageSender } = card;
        return {
            customers: [{
                id: packageSender.id,
                email: packageSender.email,
                userName: packageSender.userName,
                firstName: packageSender.firstName,
                lastName: packageSender.lastName
            }],
            silentUsers: card.owners.map(o => ({
                ...o,
                id: o.customerId,
                ownerId: packageSender.id
            }))
        }
    }

    return consignmentOwnerMap(card.owners);
}

const consignmentOwnerMap = (owners: AccountOwner[]) => ({
    customers: owners.map(o => ({
        ...o,
        id: o.customerId,
    })),
    silentUsers: []
});

export const ownershipUpdate = (initial: Owners, current: Owners): Owners => {
    if (
        initial.customers.length === current.customers.length &&
        initial.customers.every(og => !!current.customers.find(c => c!.id === og!.id)) &&
        initial.silentUsers.length === current.silentUsers.length &&
        initial.silentUsers.every(og => !!current.silentUsers.find(c => c!.accountId === og!.accountId))
    ) {
        // no change, don't send any ownership data
        return { customers: [], silentUsers: [] };
    }

    return current;
}